"use client";

import { useState } from "react";
import { cn } from "@/src/lib/utils";

import { AccordionItem } from "./AccordionItem";
import type { AccordionProps } from "./Accordion.types";

export function Accordion({ items, defaultOpenIndex = 0, className }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpenIndex);

  const handleToggle = (index: number) => {
    if (openIndex !== index) {
      setOpenIndex(index);
      return;
    }

    setOpenIndex((index + 1) % items.length);
  };

  return (
    <div className={cn(className)}>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          open={openIndex === index}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </div>
  );
}
